(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.agent:mxQuickStartPanel
	 * @module mx.agent
	 * @description Displays quick link for quick starts
	 * @param {string} data@ - Complex data. Array of objects
	 * @param {string} navigateTo@ - enum: ['dataset', 'navigation'], what should be used for navigation: contentWidgetId or baseNavigationId
	 * 			Dataset can be used if the same DataSetWidget is used in different applications with different NavigationItem.
	 * 			In this case baseNavigationId will be different for each application, so it cannot be configured correctly.
	 * @param {string} baseNavigationId@ - ID of navigation item, in which object will be shown
	 * @param {string} contentWidgetId@ - ID of Widget, in which object will be shown
	 * @param {string} titleFieldName@ - name of field with title of object
	 * @param {string} objectIdFieldName@ - name of field with ObjectId of object
	 * @param {string} imageFieldName@ - name of field with image of object
	 */
	angular.module('mx.SolutionBuilderAgent').component('mxQuickStartPanel', {
		bindings: {
			data: '<',
			navigateTo: '@',
			baseNavigationId: '@',
			contentWidgetId: '@',
			titleFieldName: '@',
			objectIdFieldName: '@',
			imageFieldName: '@',
		},
		controller: MxQuickStartPanelCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-quick-start-panel/mx-quick-start-panel.html',
	});

	MxQuickStartPanelCtrl.$inject = [
		'$element',
		'$scope',
		'$stateParams',
		'$q',
		'mx.shell.AppsService',
		'mx.shell.RoutingService',
		'mx.internationalization',
		'mx.shell.HostUrlHelper',
		'mx.shell.EventService',
		'mx.shell.NavigationItemsLoaderService',
	];

	function MxQuickStartPanelCtrl($element, $scope, $stateParams, $q, appsService, routingService, i18n, hostUrlHelper, eventService, navigationItemsLoaderService) {
		var vm = this;

		vm.columns = 0;
		vm.tileWidth = 250;
		vm.maxNumOfRows = 2;
		vm.maxChildrenPerColumn = 10;
		vm.columnsPerTile = 1.5;
		vm.maxNumberOfSubCategoriesInTile = 4;
		vm.gutter = 8;

		vm.i18n = i18n.get('solutionBuilderAgent.common');

		vm.openLink = openLink;
		vm.getImage = getImage;
		vm.showAllCategories = showAllCategories;

		vm.$onInit = function () {
			var dataWatcher = $scope.$watch('vm.data', function () {
				if (vm.data && vm.data.length > 0) {
					dataWatcher();

					getNavigationId().then(function (navigationId) {
						if (navigationId) {
							navigationItemsLoaderService.setNavigationIdForStructure(navigationId, vm.data, vm.objectIdFieldName);
						}
					});

					/* DON'T REMOVE THIS COMMENT. clone subitems for debug */
					/*vm.data.forEach(function(item, key) {
						var children = [];
						for (var i = 0; i < (key+1)*3; i++) {
							item.Children.forEach(function(child) {
								var cloneChild = angular.copy(child);
								cloneChild[vm.objectIdFieldName] = child[vm.objectIdFieldName] + '' + i;
								children.push(cloneChild);
							});
						}
						item.Children = children;
					});
					var cloneData = [];
					for (var i = 0; i < 3; i++) {
						vm.data.forEach(function (item) {
							var cloneItem = angular.copy(item);
							cloneItem[vm.objectIdFieldName] = item[vm.objectIdFieldName] + '' + i;
							cloneData.push (cloneItem);
						});
					}
					vm.data = cloneData;*/
					/* end cloning */

					updateLayout();
				}

				updateLayout();
			});

			eventService.subscribeTo(mx.shell.EventCodes.LayoutChanged, updateLayout, $scope);

			appsService.getCurrentApplication().then(function (app) {
				vm.appName = app.name;
			});
		};

		var debouncedRecalculatePages = $.debounce(500, recalculatePages);

		function updateLayout() {
			$scope.$evalAsync(function () {
				if (!$element.is(':visible')) {
					return;
				}

				var elementWidth = $element.width();
				var newColumns = Math.max(Math.floor(elementWidth / vm.tileWidth), 1);
				vm.needPaging = vm.data.length > newColumns * 2;

				if (vm.needPaging) {
					elementWidth -= 90; // padding of carousel 45 + 45
					newColumns = Math.max(Math.floor(elementWidth / vm.tileWidth), 1);
				}
				vm.twoLinesMode = vm.data.length > newColumns;
				debouncedRecalculatePages(newColumns);
			});
		}

		function recalculatePages(newColumns) {
			$scope.$evalAsync(function () {
				if (vm.columns !== newColumns) {
					vm.columns = newColumns;
					if (Array.isArray(vm.data)) {
						vm.carouselPages = calcCarouselPages(vm.data, vm.columns);
						vm.childrenGroups = calcShowAllChildrenView(vm.data, vm.columns);
					}
					vm.showAll = false;
				}
			});
		}

		/**
		 * Get Navigation Item Id which are configured directly or related to configured DataSetWdiget
		 *
		 * @returns {GUID}
		 */
		function getNavigationId() {
			if ((vm.navigateTo === 'dataset' || typeof vm.navigateTo === 'undefined') && vm.contentWidgetId) {
				return navigationItemsLoaderService.getNavigationItemsOfWidget(vm.contentWidgetId).then(function (navItems) {
					return (navItems[0] || {}).id;
				});
			} else {
				return $q.when(vm.baseNavigationId);
			}
		}

		/** forming children columns to show in big tile **/
		function calcShowAllChildrenView(categories, columns) {
			var childrenGroups = {};
			categories.forEach(function (category) {
				if (!category.Children || category.Children.length <= vm.maxNumberOfSubCategoriesInTile) {
					return;
				}
				var numOfTiles = Math.min(columns, Math.ceil(Math.ceil(category.Children.length / vm.maxChildrenPerColumn) / vm.columnsPerTile));

				childrenGroups[category[vm.objectIdFieldName]] = {
					numOfTiles: numOfTiles,
					columns: [],
					leftPos: category.__numOfTileInRow,
				};

				if (numOfTiles + category.__numOfTileInRow > vm.columns) {
					childrenGroups[category[vm.objectIdFieldName]].leftPos = vm.columns - numOfTiles;
				}

				childrenGroups[category[vm.objectIdFieldName]].childrenPerColumn = Math.ceil(
					category.Children.length / Math.floor(vm.columnsPerTile * childrenGroups[category[vm.objectIdFieldName]].numOfTiles)
				);

				category.Children.forEach(function (child, key) {
					var column = Math.floor(key / childrenGroups[category[vm.objectIdFieldName]].childrenPerColumn);
					if (typeof childrenGroups[category[vm.objectIdFieldName]].columns[column] === 'undefined') {
						childrenGroups[category[vm.objectIdFieldName]].columns[column] = [];
					}
					childrenGroups[category[vm.objectIdFieldName]].columns[column].push(child);
				});
			});

			return childrenGroups;
		}

		function calcBigItemPosition() {
			if (!vm.bigItem || !vm.childrenGroups[vm.bigItem[vm.objectIdFieldName]]) {
				return;
			}
			var group = vm.childrenGroups[vm.bigItem[vm.objectIdFieldName]];

			var tilePercentWidth = 1 / vm.columns;
			var gutterBorder = vm.gutter * (1 - tilePercentWidth);
			var gutterOffset = (group.numOfTiles - 1) * vm.gutter;
			tilePercentWidth *= 100;

			group.left = 'calc(((' + tilePercentWidth + '% - ' + gutterBorder + 'px) + ' + vm.gutter + 'px) * ' + group.leftPos + ')';
			group.width = 'calc(((' + tilePercentWidth + '% - ' + gutterBorder + 'px) * ' + group.numOfTiles + ') + ' + gutterOffset + 'px)';
		}

		function calcCarouselPages(categories, columns) {
			var carouselPages = [];
			if (Array.isArray(categories)) {
				categories.forEach(function (category, index) {
					var page = Math.floor(index / (columns * vm.maxNumOfRows));
					if (typeof carouselPages[page] === 'undefined') {
						carouselPages[page] = {
							categories: [],
							body: '<ng-include src="\'workspaces/SolutionBuilderAgent/components/mx-quick-start-panel/mx-quick-start-page-template.html\'"></ng-include>',
						};
					}
					category.__numOfTileInRow = (index - page * (columns * vm.maxNumOfRows)) % columns;
					carouselPages[page].categories.push(category);
				});
			}
			return carouselPages;
		}

		function showAllCategories(item) {
			vm.showAll = true;
			vm.bigItem = item;
			calcBigItemPosition();
		}

		function openLink(item) {
			if (item.navigationId) {
				routingService.go('searchPage', {
					navigationId: item.navigationId,
					appString: vm.appName,
					filterType: 'structure',
					filterId: item[vm.objectIdFieldName],
				});
			}
		}

		function getImage(item) {
			return hostUrlHelper.getFullImageUrl(item[vm.imageFieldName]);
		}
	}
})();
